// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index-card__summary[data-v-d4c74060]{align-items:flex-start;display:flex;flex-direction:column;grid-gap:var(--unit-0400);gap:var(--unit-0400)}.index-card__summary__link[data-v-d4c74060]{text-align:left}.index-card__expand-button[data-v-d4c74060]{justify-content:start;min-height:0;padding:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
